import { Locale } from "@redotech/crdb-enums/common/locale";
import { normalizeLanguageCode } from "@redotech/redo-common-model/locale-codes";
import * as z from "zod";

export const emailTemplateSupportedLocaleSchema = z.enum(Locale);

export type EmailTemplateSupportedLocale = z.infer<
  typeof emailTemplateSupportedLocaleSchema
>;

/** Accepts region-tagged or uppercase codes, e.g. "fr-CA" and "FR" parse to "fr". */
export const emailTemplateSourceLocaleSchema = z.preprocess((value) => {
  if (value == null || (typeof value === "string" && value.trim() === "")) {
    return undefined;
  }
  return typeof value === "string" ? normalizeLanguageCode(value) : value;
}, emailTemplateSupportedLocaleSchema);

export type EmailTemplateSourceLocale = EmailTemplateSupportedLocale;

export function parseEmailTemplateSourceLocale(
  value: unknown,
): EmailTemplateSourceLocale | undefined {
  const parsed = emailTemplateSourceLocaleSchema.safeParse(value);
  return parsed.success ? parsed.data : undefined;
}

export interface EmailTemplateLocaleCopy<TSections> {
  subject: string;
  emailPreview?: string | null;
  sections: TSections;
}

export function resolveEmailTemplateForLocale<
  T extends {
    subject: string;
    emailPreview?: string | null;
    sections: unknown;
  },
>(
  source: T,
  localeCopy: EmailTemplateLocaleCopy<T["sections"]> | null | undefined,
): T {
  if (localeCopy == null) {
    return source;
  }
  return {
    ...source,
    subject: localeCopy.subject,
    emailPreview: localeCopy.emailPreview,
    sections: localeCopy.sections,
  };
}
